import { render, staticRenderFns } from "./CitiesTable.vue?vue&type=template&id=a7387f0c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./CitiesTable.vue?vue&type=script&lang=js"
export * from "./CitiesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7387f0c",
  null
  
)

export default component.exports